import React from 'react'

export default function MessageSubmitArrow() {

    return (
        <>
            <svg  width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5418 0.832031V24.6747L3.57516 13.7081L0.833496 16.4987L16.5002 32.1654L32.1668 16.4987L29.4252 13.7081L18.4585 24.6747V0.832031H14.5418Z" fill="white" />
            </svg>
        </>
    )
}
